import { render } from "./wokerDetail18.vue?vue&type=template&id=f620c79a&scoped=true"
import script from "./wokerDetail18.vue?vue&type=script&lang=js"
export * from "./wokerDetail18.vue?vue&type=script&lang=js"

import "./wokerDetail18.vue?vue&type=style&index=0&id=f620c79a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f620c79a"]])

export default __exports__